<!-- eslint-disable max-lines -->
<template>
    <div class='g-seven-list'>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="GSevenQuery"
            pageID="GSeven"
            @edit-btn="editBtn"
            @del-btn="delBtn"
            @arrive-btn ='arriveBtn'
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_G7">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp04080002'">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="againClick">重新推送</el-button>
                <el-button type="primary" @click="arriveClick">抵达推送</el-button>
            </div>
        </m-pane>
        <edit-dialog
            v-if="visiableDialog"
            :label-position="labelPosition"
            :visiableDialog.sync="visiableDialog"
            :data="dataObj"
            @handleClose="handleClose"
            @saveOk="saveOk">
        </edit-dialog>
        <arrive-dialog
            v-if='arriveVisiable'
            :arriveVisiable.sync="arriveVisiable"
            :rowData ='rowData'
            @arriveSaveOk="arriveSaveOk"
        >
        </arrive-dialog>
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import mPane from '@/components/otpPanel';
import config from './config.js';
import EditDialog from './Edit';
import arriveDialog from './arriveDialog';
import reportExport from '@/components/lots/reportExportPlugin';
import { getLists, getAgainLists, deleteList, arrivePush } from '../../../../api/vehicleFreePlatform';
import formatTime from '@/utils/common.js';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { mPane, EditDialog, arriveDialog, reportExport },
    data() {
        return {
            selected: [],
            searchDataLists: {
                pageNo: 1,
                pageSize: 10,
                noCarCarrierType: '20'
            },
            dataObj: {},
            currentPage: 1,
            selectData: [],
            pageTotal: 0,
            totalData: [],
            loading: false,
            config,
            labelPosition: 'right',
            visiableDialog: false,
            activeName: 'first',
            arriveVisiable: false,
            rowData: {},
            isFirstSearch: true
        };
    },
    methods: {
        async load() {
            this.currentPage = this.searchDataLists.pageNo;
            const startTime = this.searchDataLists.beginDate || 0;
            const endTime = this.searchDataLists.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!this.searchDataLists.dispatchNo && !startTime) {
                return this.$message.warning('发车单号 和 创建时间 不可同时为空');
            } else if (!this.searchDataLists.dispatchNo && startTime) {
                if (timeDifference > 63 * 24 * 60 * 60 * 1000) {
                    return this.$message.warning('按时间查询时，查询时间跨度不可超过两个月！');
                }
            }
            const dict = await dictWithUrl('S_F_FLAG');
            const dictData = dict.data;
            this.loading = true;
            getLists(this.searchDataLists).then(res => {
                if (res) {
                    this.pageTotal = res.data.totalCount;
                    this.loading = false;
                    this.totalData = res.data.list || [];
                    this.totalData.map(item => {
                        item.statusText = dictData.S_F_FLAG[item.status] || item.status;
                        item.isArriName = item.isArri === 'Y' ? '是' : '否';
                        if (item.status === 'SUCCESS') {
                            item.hiddenEvent = [ 'edit' ];
                        } else {
                            item.hiddenEvent = [ 'delete', 'arrive' ];
                        }
                    });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        againClick() {
            if (this.selected.length === 0) {
                this.$message.warning('至少选择一条数据');
                return;
            } else if (this.selected.length > 20) {
                this.$message.warning('最多只能选择20条数据');
                return;
            }
            for (let index = 0; index < this.selected.length; index++) {
                if (this.selected[index].status === 'SUCCESS') {
                    this.$message.warning('成功状态下不能再次推送');
                    return;
                }
            }
            const arr = [];
            this.selected.forEach(item => {
                arr.push({ dispatchNo: item.dispatchNo, status: item.status });
            });
            getAgainLists(arr).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('重新推送成功');
                }
                this.load();
            });
        },
        arriveClick() {
            if (!this.selected.length) {
                return this.$message.warning('至少选择一条数据！');
            }
            const params = this.selected.map(item => {
                const { dispatchNo, depTime, arriTime } = item;
                return {
                    dispatchNo,
                    depTime,
                    arriTime
                };
            });
            arrivePush(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('抵达推送成功');
                    this.load();
                }
            });
        },
        editBtn(data) {
            this.dataObj = data;
            this.dispatchNo = data.dispatchNo;
            this.visiableDialog = true;
        },
        arriveBtn(rowData) {
            this.rowData = rowData;
            this.arriveVisiable = true;
        },
        handleClose() {
            this.visiableDialog = false;
        },
        pageChange(data) {
            this.searchDataLists.pageNo = data;
            this.load();
        },
        sizeChange(data) {
            this.searchDataLists.pageSize = data;
            this.searchDataLists.pageNo = 1;
            this.load();
        },
        searchChange(data) {
            if (data.createTime !== null && data.createTime !== '') {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else {
                data.beginDate = '';
                data.endDate = '';
            };
            this.dispatchNo = data.dispatchNo;
            this.status = data.status;
            this.siteCode = data.siteCode;
            delete data.createTime;
            this.searchDataLists = {
                ...this.searchDataLists,
                ...data,
                pageNo: 1
            };
            this.isFirstSearch = false;
            this.load();
        },
        selectChange(data) {
            data.forEach(item => {
                this.dispatchNo = item.dispatchNo;
            });
            this.selected = [].concat(data);
        },
        delBtn(data) {
            this.$confirm('确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteList(data.dispatchNo).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('删除成功');
                        this.load();
                    }
                });
            }).catch(() => {});
        },
        saveOk(data) {
            if (data) {
                this.visiableDialog = false;
                this.load();
            }
        },
        arriveSaveOk() {
            this.arriveVisiable = false;
            this.load();
        },
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchDataLists,
                tenantCode: 'BLANK'
            });
        }
    }
};
</script>

<style lang="less">
.g-seven-list {
    .text-color {
        text-align: center;
        width: 50px;
        display: inline-block;
    }
    .el-tabs__item {
        height: 28px !important;
        line-height: 28px !important;
    }
    .el-tabs__header {
        margin: 0 0 10px;
    }
}
</style>
